import { TFunction } from "i18next";
import DefaultIzProvider from "./DefaultIzProvider";

export class NewJersey extends DefaultIzProvider {
  constructor(izDestinationId: string, t: TFunction) {
    super(izDestinationId, t);
    this.scenarioBImagePath = "/assets/images/large/Docket_Jersey_scb_f.png";

    this.statusImages.dueNowImagePath = "/assets/images/dueNJ.png";
    this.statusImages.noRecordImagePath = "/assets/images/noRecordNJ.png";
    this.statusImages.dueNowLabel = "due";
    this.statusImages.noRecordLabel = "no_record";
    this.statusImages.redOnDue = true;
    this.statusImages.useNoRecordImage = true;
    this.reportTitles = [
      t("immunizations.records_history_report_fullnj"),
      // This is the Covid-19 report which NJ wants to disable as of 2025-02-12
      // t("immunizations.records_history_report_nj"),
    ];
    this.screeningResultLink = "https://www.nj.gov/health/childhood-lead/";
  }

  fillOutI18nDefinitions(): never {
    throw new Error("Method not implemented.");
  }
}
